<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <resource-index header="Salesforce (Relatie) Contacten" endpoint="accounts/contacts" show-route="contacts.view" />
      </div>
    </div>
  </div>
   
</template>
<script>
import ResourceIndex from '../../components/ResourceIndexGroup';

export default {
  name: 'users',
  components: { ResourceIndex }
}

</script>
